import { createSlice } from '@reduxjs/toolkit';
import {
  USER_ROLES,
  getGlobalToggleState,
  UserUtilities,
} from '@pwc/pwc-deals-web-common';

/**
  Example state data:
    {
      initials: "AF"
      givenName: "Adrien"
      familyName: "Fontannaz"
      name: "Adrien Fontannaz"
    }
*/

const initialUserRole =
  getGlobalToggleState() ||
  (UserUtilities.isUserInternal() ? USER_ROLES.PWC_USER : USER_ROLES.CLIENT);

export const initialState = {
  userRole: initialUserRole,
  /**
   * actualUserRole is not taking into account the global toggle (impersonification)
   * and should ONLY be used in situations where global toggle is not applicable.
   */
  actualUserRole:
    UserUtilities.isActualPwcUser() === true
      ? USER_ROLES.PWC_USER
      : USER_ROLES.CLIENT,
};

const loggedInUserSlice = createSlice({
  name: 'loggedInUser',
  initialState,
  reducers: {
    setLoggedInUserSucceeded: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setActualUserRole: (state, action) => {
      return {
        ...state,
        actualUserRole: action.payload,
      };
    },
    setUserRole: (state, action) => {
      return {
        ...state,
        userRole: action.payload,
      };
    },
  },
});

export const getUserRole = (state) => state.loggedInUser.userRole;
export const getActualUserRole = (state) => state.loggedInUser.actualUserRole;
export const getIsThirdPartyMember = (state) =>
  state.loggedInUser.actualUserRole === USER_ROLES.THIRD_PARTY;
export const getFakeClientUser = (state) =>
  state.loggedInUser.actualUserRole === USER_ROLES.PWC_USER &&
  state.loggedInUser.userRole === USER_ROLES.CLIENT &&
  state.loggedInUser.userRole === USER_ROLES.THIRD_PARTY;

export const {
  setLoggedInUserSucceeded,
  setGlobalToggleRole,
  setUserRole,
  setActualUserRole,
} = loggedInUserSlice.actions;

export default loggedInUserSlice.reducer;
